module.exports = __webpack_public_path__ + "img/zoom1.d9012967.svg";